import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import PriorityImage from '../../components/PriorityImage/PriorityImage';
import type { Tournament } from '../../types/MTT';

import { TXTCLI_Buy_In, TXTCLI_Prize_Pool } from './TournamentCard.messages.json';
import styles from './TournamentCard.scss';
import TournamentTime from './TournamentTime/TournamentTime';

const TournamentCard: React.FC<{
  tournament: Tournament;
  className?: string;
  onClick?: () => void;
}> = ({ tournament, className, onClick }) => {
  const { fallbackImageUrl, imageSquareUrl, formattedName, formattedBuyIn, formattedPrizePool } =
    tournament;

  return (
    <div className={classNames(styles.root, className)} onClick={onClick}>
      <div className={styles.image}>
        <PriorityImage
          imageUrl={imageSquareUrl}
          fallbackUrl={fallbackImageUrl}
          altText={formattedName || ''}
          fetchPriority="high"
        />
        <TournamentTime tournament={tournament} />
      </div>
      <div className={styles.content}>
        <div className={styles.name} dangerouslySetInnerHTML={{ __html: formattedName }} />
        <div className={styles.info}>
          <div className={styles.item}>
            <div className={styles.label}>
              <Translation {...TXTCLI_Buy_In} />
            </div>
            <div className={styles.value}>{formattedBuyIn}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.label}>
              <Translation {...TXTCLI_Prize_Pool} />
            </div>
            <div className={styles.value}>{formattedPrizePool}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentCard;
